var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 19.5,
    viewBox: "0 0 19.5 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar-svgrepo-com_1_",
    "data-name": "calendar-svgrepo-com (1)",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6786",
    "data-name": "Path 6786",
    d: "M2,11.333C2,7.876,2,6.148,3.054,5.074S5.806,4,9.2,4h3.6c3.394,0,5.091,0,6.146,1.074S20,7.876,20,11.333v1.833c0,3.457,0,5.185-1.054,6.259S16.194,20.5,12.8,20.5H9.2c-3.394,0-5.091,0-6.146-1.074S2,16.624,2,13.167Z",
    transform: "translate(-2 -2.5)",
    fill: "none",
    stroke: "#9facbe",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6787",
    "data-name": "Path 6787",
    d: "M7,4V2.5",
    transform: "translate(-2.5 -2.5)",
    fill: "none",
    stroke: "#9facbe",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6788",
    "data-name": "Path 6788",
    d: "M17,4V2.5",
    transform: "translate(-3.5 -2.5)",
    fill: "none",
    stroke: "#9facbe",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6789",
    "data-name": "Path 6789",
    d: "M2.5,9h17",
    transform: "translate(-2 -3)",
    fill: "none",
    stroke: "#9facbe",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6790",
    "data-name": "Path 6790",
    d: "M18,17a1,1,0,1,1-1-1A1,1,0,0,1,18,17Z",
    transform: "translate(-3.556 -3.657)",
    fill: "#9facbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6791",
    "data-name": "Path 6791",
    d: "M18,13a1,1,0,1,1-1-1A1,1,0,0,1,18,13Z",
    transform: "translate(-3.556 -3.314)",
    fill: "#9facbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6792",
    "data-name": "Path 6792",
    d: "M13,17a1,1,0,1,1-1-1A1,1,0,0,1,13,17Z",
    transform: "translate(-3 -3.657)",
    fill: "#9facbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6793",
    "data-name": "Path 6793",
    d: "M13,13a1,1,0,1,1-1-1A1,1,0,0,1,13,13Z",
    transform: "translate(-3 -3.314)",
    fill: "#9facbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6794",
    "data-name": "Path 6794",
    d: "M8,17a1,1,0,1,1-1-1A1,1,0,0,1,8,17Z",
    transform: "translate(-2.444 -3.657)",
    fill: "#9facbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6795",
    "data-name": "Path 6795",
    d: "M8,13a1,1,0,1,1-1-1A1,1,0,0,1,8,13Z",
    transform: "translate(-2.444 -3.314)",
    fill: "#9facbe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointment);
export default __webpack_public_path__ + "static/media/appointment.ca6161c845cb0b3a9cb88086301ceb89.svg";
export { ForwardRef as ReactComponent };